import type { ReactNode } from "react";
import type { Role } from "../state/api.types";
import { useAuthHasRole } from "../state/hooks";
import { ForbiddenPage } from "./ForbiddenPage";

type RequireRoleProps = {
  roles: Role[];
  children: ReactNode | ReactNode[];
};

export function RequireRole(props: RequireRoleProps) {
  const hasPermission = useAuthHasRole(...props.roles);
  if (hasPermission) {
    return props.children;
  }
  return <ForbiddenPage />;
}
